export default {
  SET_GEOGRAPHY_INVESTING(state, payload) {
    state.geographyInvestingData = {
      equityByDomicile: payload.ByEquityDomicile,
      equityByRevenue: payload.ByEquityRevenue,
      strategyByDomicile: payload.ByDomicile,
      asOfDate: payload.asOfDate,
      charts: payload.charts
    };
  }
};
